import * as React from "react";
import { Button } from "@fluentui/react-components";
import { ui } from "../theme";

interface LoginScreenProps {
  onLogin: () => Promise<void>;
  error?: string | null;
}

export const LoginScreen: React.FC<LoginScreenProps> = ({ onLogin, error: externalError }) => {
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);
  const displayError = externalError || error;

  const handleLogin = async () => {
    setLoading(true);
    setError(null);
    try {
      await onLogin();
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setLoading(false);
    }
  };

  return React.createElement(
    "div",
    {
      style: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        padding: 24,
        gap: 16,
      },
    },
    React.createElement("img", {
      src: "assets/brand/logo-white.svg",
      alt: "Paebbl",
      style: { height: 56, display: "block" },
    }),
    React.createElement(
      "h2",
      { style: { margin: 0, color: ui.text, fontWeight: 600 } },
      "ModelFabric"
    ),
    React.createElement(
      Button,
      { appearance: "primary", onClick: handleLogin, disabled: loading },
      loading ? "Signing in..." : "Sign in"
    ),
    displayError && React.createElement("div", { style: { color: ui.errorFg } }, displayError)
  );
};
